import { action, observable, set } from "mobx";

export default class TourAcl {
  /**
   * @property {boolean}
   */
  @observable info = false;

  /**
   * @property {boolean}
   */
  @observable download = false;

  /**
   * @property {boolean}
   */
  @observable address = false;

  /**
   * @property {boolean}
   */
  @observable mls = false;

  /**
   * @property {boolean}
   */
  @observable settings = false;

  /**
   * @property {boolean}
   */
  @observable immersive3dTour = false;

  /**
   * @property {boolean}
   */
  @observable uiMeet3d = false;

  /**
   * @property {boolean}
   */
  @observable mediaEdit = false;

  /**
   * @property {boolean}
   */
  @observable mediaSettings = false;

  /**
   * @property {boolean}
   */
  @observable videoRequest = false;

  /**
   * @property {boolean}
   */
  @observable flyer = false;

  /**
   * @property {boolean}
   */
  @observable stats = false;

  /**
   * @property {boolean}
   */
  @observable links = false;

  /**
   * @property {boolean}
   */
  @observable ransomReview = false;

  constructor(data) {
    if (data !== undefined) {
      this.setData(data);
    }
  }

  @action
  setData(data) {
    set(this, data);
  }
}
